import InstructorFormativeJourneyPage from 'pages/InstructorFormativeJourney';
import InstructorFormativeSubmissionsPage from 'pages/InstructorFormativeSubmissions';
import PageLayout from 'pages/InstructorSubmissions/PageLayout';
import PageProvider from 'pages/InstructorSubmissions/PageProvider';
import { useLocation } from 'react-router-dom';

const InstructorSubmissionsPage = ({ ...props }) => {
    const location = useLocation();
    const currentParams = new URLSearchParams(location.search);

    if (currentParams.get('type') === 'formative' && Boolean(currentParams.get('owner_account_id'))) {
        return <InstructorFormativeJourneyPage />;
    }

    if (currentParams.get('type') === 'formative') return <InstructorFormativeSubmissionsPage />;

    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorSubmissionsPage;
